import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { LucideAngularModule, BookOpen, X, Link2 } from 'lucide-angular';
import { THEME_COLOR } from '../../../../grading.types';

export interface StandardInfoData {
  /** Standard code (e.g., "CCSS.MATH.8.EE.A.1") */
  code: string;
  /** Full standard text */
  text: string;
  /** Alignment rationale - why this standard applies */
  alignmentRationale?: string;
  /** Criteria name this standard is aligned to */
  criteriaName: string;
}

@Component({
  selector: 'app-standard-info-modal',
  standalone: true,
  imports: [CommonModule, LucideAngularModule],
  templateUrl: './standard-info-modal.html',
  styleUrl: './standard-info-modal.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StandardInfoModalComponent {
  @Input({ required: true }) data!: StandardInfoData;
  @Output() readonly close = new EventEmitter<void>();

  protected readonly themeColor = THEME_COLOR;
  protected readonly icons = { BookOpen, X, Link2 };

  protected onBackdropClick(): void {
    this.close.emit();
  }

  protected onCloseClick(): void {
    this.close.emit();
  }

  protected stopPropagation(event: Event): void {
    event.stopPropagation();
  }
}
